/*
  Resolves links rendered by snippets/lpb-link-href.liquid for pages flagged
  custom.obfuscate_links: the real URL lives base64-encoded in data-lpb-href so
  crawlers never see an <a href> to it. Delegated, so it also covers links
  injected later (menus, drawers).
*/
(function () {
  function target(el) {
    try {
      return atob(el.getAttribute('data-lpb-href'));
    } catch (e) {
      return null;
    }
  }

  function open(event) {
    var link = event.target.closest && event.target.closest('a[data-lpb-href]');
    if (!link) return;
    var url = target(link);
    if (!url) return;
    event.preventDefault();
    if (event.ctrlKey || event.metaKey || event.button === 1 || link.target === '_blank') {
      window.open(url, '_blank', 'noopener');
    } else {
      window.location.assign(url);
    }
  }

  document.addEventListener('click', open);
  document.addEventListener('auxclick', function (event) {
    if (event.button === 1) open(event);
  });
})();
